<template>
	<div>
		<div>
			<SearchableTable :panel-header="'Medikamente'" :panel-route="'AddMedication'" :show-search-bar="true"
				:table-data="medicationData" :table-meta-data="tableMetaData" :query-string="'setMedicationSearchQuery'"
				:event-value="parentEventValue">
				<b-table-column v-slot="props" label="Aktionen" cell-class="has-text-right truncate-column"
					header-class="th-right truncate-column">
					<b-button class="is-small mr-2" @click="triggerView(props.row)">
						<b-icon class="mt-1" icon="eye" style="cursor: pointer" />
					</b-button>
					<b-button class="is-small mr-2" @click="triggerEdit(props.row)">
						<b-icon class="mt-1" icon="pencil" style="cursor: pointer;" />
					</b-button>
					<b-button class="is-small" @click="triggerDelete(props.row)">
						<b-icon class="mt-1" icon="delete" style="cursor: pointer" />
					</b-button>
				</b-table-column>
			</SearchableTable>

			<b-modal v-model="isDeleteCheck">
				<div v-if="isDeleteCheck" class="panel m-5" style="background-color: white">
					<p class="panel-heading">
						Möchtest du "{{ chosenElement.attributes.name }}" wirklich löschen?
					</p>
					<div class="buttons mt-2" style="display: flex; justify-content: center">
						<b-button class="is-danger" :loading="isLoading" @click="submitDelete()">
							Ja
						</b-button>
						<b-button class="is-primary" @click="closeModal">
							Nein
						</b-button>
					</div>
				</div>
			</b-modal>
		</div>
	</div>
</template>
 
<script>
/**
 * This file shows all currently stored medications and allows adding, editing, viewing and soft deleting these.
 */
import { negativeFeedBack, positiveFeedBack } from "@/lib/Toast";
import { mapGetters } from "vuex";
import SearchableTable from "@/components/helperComponents/SearchableTable.vue";
export default {
	name: "MedicationTable",
	components: { SearchableTable },
	data() {
		return {
			parentEventValue: undefined,
			isDeleteCheck: false,
			chosenElement: {},
			isLoading: false,
			tableMetaData: [
				{ "id": 0, "type": "string", "label": "Bezeichner", "field": "name", "sortField": "attributes.name" },
				{ "id": 1, "type": "string", "label": "Stärke", "field": "potency", "sortField": "attributes.potency" },
				{ "id": 2, "type": "combination", "label": "Anzahl/(Füll-)Menge", "symbol": " ", "alternativeSymbol": " ", "field": [["max"], ["medicationUnit", "symbol"]], "sortField": "attributes.max" },
				{ "id": 3, "type": "ref", "label": "Art", "field": "name", "sortField": "attributes.medicationForm.attributes.name", "refName": "medicationForm" },
			]
		};
	},
	computed: {
		...mapGetters({
			medicationData: "getMedication"
		})
	},
	mounted() { },
	methods: {
		triggerEdit(element) {
			this.$router.push({ name: "AddMedication", params: { data: element } });
		},
		triggerView(element) {
			this.$router.push({ name: "ViewMedication", params: { data: element } });
		},
		triggerDelete(element) {
			this.chosenElement = element;
			this.isDeleteCheck = true;
		},
		closeModal() {
			this.isDeleteCheck = false;
		},
		async submitDelete() {
			this.isLoading = true
			this.chosenElement.set("deleted", true);
			this.chosenElement.save().catch((e) => {
				negativeFeedBack(this.chosenElement.attributes.name + " nicht gelöscht!")
			});
			await positiveFeedBack(this.chosenElement.attributes.name + " gelöscht!")
			this.isLoading = false
			this.isDeleteCheck = false
		}
	},
};

</script>
  
<style scoped></style>
  